module.exports = __webpack_public_path__ + "img/company-img1.15e8357b.png";